<ng-container *ngIf="score >= 0; else noLongerMatched">
	{{score > 100 ? 100 : score }}%
</ng-container>
<ng-template #noLongerMatched>
	No longer matched
</ng-template>
